import React, { useCallback, useEffect } from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import SecurityPageWrapper from '../security-page-wrapper/SecurityPageWrapper';
import {
  confirmChangePassword,
  confirmLogin,
  sendForgotPasswordOtpAgain,
  sendLoginOtpAgain,
} from '../../redux/security/securityActions';
import OtpForm from './OtpForm';
import { useNavigate } from 'react-router';

const Otp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoginOtp, uuid } = useSelector((state) => state.securityNew);

  const otpInitialValues = {
    otp: '',
  };

  const handleConfirm = useCallback(
    (values) => {
      dispatch(isLoginOtp ? confirmLogin(values) : confirmChangePassword(values));
    },
    [isLoginOtp, dispatch],
  );

  const handleResendEmail = useCallback(() => {
    dispatch(isLoginOtp ? sendLoginOtpAgain() : sendForgotPasswordOtpAgain());
  }, [isLoginOtp, dispatch]);

  const validation = useCallback((values) => {
    const errors = {};

    if (!values.otp || !values.otp.trim()) {
      errors.otp = 'required';
    }

    return errors;
  }, []);

  useEffect(() => {
    if (!uuid) {
      navigate('/login');
    }
  }, [uuid]);

  return (
    <SecurityPageWrapper>
      <Form
        initialValues={otpInitialValues}
        onSubmit={handleConfirm}
        validate={validation}
        validateOnBlur={false}
        subscription={{
          submitting: true,
          pristine: true,
          hasValidationErrors: true,
        }}
        render={({ handleSubmit }) => <OtpForm handleSubmit={handleSubmit} onResendEmail={handleResendEmail} />}
      />
    </SecurityPageWrapper>
  );
};

export default Otp;
